import React, { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV_LINKS, IMAGES } from "../mock";
import { Button } from "./ui/button";

export default function Navbar({ onWaitlist }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#07090a]/90 backdrop-blur-md border-b border-[#2fd645]/20"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <a href="#top" onClick={(e) => { e.preventDefault(); go("#top"); }} className="flex items-center">
            <img src={IMAGES.logo} alt="InstantDrive" className="h-11 w-auto" />
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                className="text-sm font-medium text-white/75 hover:text-[#2fd645] transition-colors duration-200"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="/app"
              className="text-sm font-semibold text-white/80 hover:text-[#2fd645] transition-colors"
            >
              Open app
            </a>
            <button
              onClick={() => go("#signup")}
              className="text-sm font-semibold text-white/80 hover:text-[#2fd645] transition-colors"
            >
              Become a driver
            </button>
            <Button
              onClick={() => go("#signup")}
              className="bg-[#2fd645] text-[#06210b] font-bold hover:bg-[#46ff5c] rounded-xl px-5"
            >
              Register <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </div>

          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </div>

      {/* mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-[#07090a]/98 backdrop-blur-md ${
          open ? "max-h-[420px] border-b border-[#2fd645]/20" : "max-h-0"
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="text-left py-3 text-base font-medium text-white/80 hover:text-[#2fd645] border-b border-white/5"
            >
              {l.label}
            </button>
          ))}
          <Button
            onClick={() => { setOpen(false); go("#signup"); }}
            className="mt-4 bg-[#2fd645] text-[#06210b] font-bold hover:bg-[#46ff5c] rounded-xl"
          >
            Register <ArrowRight className="ml-1.5 h-4 w-4" />
          </Button>
          <a
            href="/app"
            className="mt-2 text-center py-3 rounded-xl border border-white/15 text-white font-semibold hover:border-[#2fd645]"
          >
            Open app
          </a>
        </div>
      </div>
    </header>
  );
}
